import {
  Input,
  Inject,
  OnInit,
  Component,
  OnChanges,
  SimpleChanges,
} from 'ng-metadata/core';
import * as $ from 'jquery';

/**
 * Dropdown Component
 *
 * Top level component that handles logic between
 * toggle directive and actual dropdown content.
 */
@Component({
  selector: 'gwDrop',
  template: '<div class="gw-drop" ng-transclude></div>',
  legacy: {
    transclude: true,
  },
})
export class DropComponent implements OnInit, OnChanges {
  // Properties
  isOpen: boolean;

  // Bindings
  @Input('<') openIf: boolean;
  @Input() name: string;
  @Input() blockPageScroll: boolean = false;

  /**
   * Constructor
   */
  constructor(
    @Inject('$scope') private $scope: ng.IScope,
    @Inject('$rootScope') private $rootScope: ng.IRootScopeService,
  ) {}

  /**
   * Component init
   */
  ngOnInit() {
    this.isOpen = this.openIf || false;

    this.$rootScope.$on('gw-close-drop', (e, data) => {
      if (this.isOpen) {
        this.$rootScope.$emit('gw-drop-closed', { name: this.name });
        this.onShow(false);
      }
      this.isOpen = false;
    });

    this.$rootScope.$on('gw-drop-opened', (e, data) => {
      if (this.isOpen) {
        this.onShow(true);
      }
    });
  }

  /**
   * On binding changes
   * @param {SimpleChanges} changes
   */
  ngOnChanges(changes: SimpleChanges) {
    if (changes.openIf) {
      this.isOpen = this.openIf;
    }
  }

  /**
   * Block the page scroll
   *
   * @param show
   */
  onShow(show: boolean) {
    // console.log(this.drop.blockPageScroll);
    if (this.blockPageScroll) {
      $('html, body')
        .css('overflow', show ? 'hidden' : 'auto');
    }
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/common/drop/drop.component.ts